import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteLocation = (locationId: number) => {
  return axios.delete(`/api/locations/${locationId}`);
};

type UseDeleteLocationOptions = {
  config?: MutationConfig<typeof deleteLocation>;
};

export const useDeleteLocation = ({ config }: UseDeleteLocationOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['locations']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: deleteLocation,
  });
};
